var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { neutralDay, mBody2, mHeader2, wBody2, wTitle1, wTitle2 } from '@teamsparta/design-system';
import { Device } from '../../../styles/_variables';
var Title = function (_a) {
    var children = _a.children, isTitle1 = _a.isTitle1;
    return _jsx(TitleWrapper, __assign({ isTitle1: isTitle1 }, { children: children }));
};
Title.defaultProps = {
    isTitle1: false,
};
export default Title;
export var TitleWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  white-space: pre-wrap;\n\n  span {\n    ", ";\n    color: ", ";\n    margin-bottom: 2px;\n  }\n\n  ", " {\n    ", ";\n    color: ", ";\n\n    span {\n      ", ";\n      color: ", ";\n      margin-bottom: 2px;\n    }\n  }\n"], ["\n  ", ";\n  color: ", ";\n  white-space: pre-wrap;\n\n  span {\n    ", ";\n    color: ", ";\n    margin-bottom: 2px;\n  }\n\n  ", " {\n    ", ";\n    color: ", ";\n\n    span {\n      ", ";\n      color: ", ";\n      margin-bottom: 2px;\n    }\n  }\n"])), function (_a) {
    var isTitle1 = _a.isTitle1;
    return (isTitle1 ? wTitle1 : wTitle2);
}, neutralDay.gray100, wBody2, neutralDay.gray100, Device.Mobile, mHeader2, neutralDay.gray100, mBody2, neutralDay.gray100);
var templateObject_1;
//# sourceMappingURL=Title.js.map